// extracted by mini-css-extract-plugin
module.exports = {"link-container":"cd01fbf7b5--link-container--b6BMy","link":"cd01fbf7b5--link--k9NUU"};